import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type { ContractLessonPrice } from '@/types/billing'

type ApiResponse<T> = { message?: string; data?: T }

function unwrapResource<T>(raw: ApiResponse<T> | T): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return (raw as ApiResponse<T>).data as T
  }
  return raw as T
}

export type ContractPricesResponse = {
  active: ContractLessonPrice | null
  history: ContractLessonPrice[]
}

export const contractPricesApi = {
  index: async (contractId: number): Promise<ContractPricesResponse> => {
    const response = await apiClient.get<ApiResponse<ContractPricesResponse>>(
      API_ENDPOINTS.CONTRACTS.LESSON_PRICES(contractId)
    )
    const data = unwrapResource(response.data)
    return {
      active: data.active ?? null,
      history: Array.isArray(data.history) ? data.history : [],
    }
  },

  store: async (
    contractId: number,
    payload: { price_per_hour: number; currency?: string; effective_from?: string }
  ): Promise<ContractLessonPrice> => {
    const response = await apiClient.post<ApiResponse<ContractLessonPrice>>(
      API_ENDPOINTS.CONTRACTS.LESSON_PRICES(contractId),
      payload
    )
    return unwrapResource(response.data)
  },
}
